import { defineMessages } from "react-intl";

const scope = "supportui.components.Pricing";

export default defineMessages({
  errors: {
    id: `${scope}.errors`,
    defaultMessage: "Errors",
  },
  upload: {
    id: `${scope}.upload`,
    defaultMessage: "Import",
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: "Save",
  },
  returnToPricing: {
    id: `${scope}.returnToPricing`,
    defaultMessage: "Return to pricing",
  },
  savingPricing: {
    id: `${scope}.savingPricing`,
    defaultMessage: "Saving pricing...",
  },
  uploadingPricing: {
    id: `${scope}.uploading`,
    defaultMessage: "Importing pricing...",
  },
  pricingUploadFailed: {
    id: `${scope}.pricingUploadFailed`,
    defaultMessage: "Pricing import failed",
  },
  pricingToBeSaved: {
    id: `${scope}.pricingToBeSaved`,
    defaultMessage: "Pricing values to be saved",
  },
  pricingSaved: {
    id: `${scope}.pricingSaved`,
    defaultMessage: "{totalCount} pricing values have been successfully saved",
  },
  pricingHeaderDeleted: {
    id: `${scope}.pricingHeaderDeleted`,
    defaultMessage: "Deleted",
  },
  pricingHeaderSupplierId: {
    id: `${scope}.pricingHeaderSupplierId`,
    defaultMessage: "SupplierId",
  },
  pricingHeaderPartnerId: {
    id: `${scope}.pricingHeaderPartnerId`,
    defaultMessage: "PartnerId",
  },
  pricingHeaderType: {
    id: `${scope}.pricingHeaderType`,
    defaultMessage: "Type",
  },
  pricingHeaderValue: {
    id: `${scope}.pricingHeaderValue`,
    defaultMessage: "Value",
  },
  pricingHeaderFromDate: {
    id: `${scope}.pricingHeaderFromDate`,
    defaultMessage: "From date",
  },
  pricingHeaderToDate: {
    id: `${scope}.pricingHeaderToDate`,
    defaultMessage: "To date",
  },
  totalCount: {
    id: `${scope}.totalCount`,
    defaultMessage: "Total count: {count} item(s)",
  },
  downloadAll: {
    id: `${scope}.downloadAll`,
    defaultMessage: "Export",
  },
  chooseOperation: {
    id: `${scope}.chooseOperation`,
    defaultMessage: "Pricing actions:",
  },
});
